export const CONTACT = {
  phone: "+91 81057 61163",
  phoneRaw: "918105761163",
  email: "sampath@atagasthya.com",
  salesEmail: "sales@atagasthya.com",
  company: "Atagasthya Packaging Private Limited",
  addressLines: [
    "SY No. 99/1, Nagondanahalli,",
    "Whitefield, Bengaluru,",
    "Karnataka 560066, India"
  ]
};

const B = (name) => `${process.env.PUBLIC_URL || ""}/brand/${name}`;

export const IMAGES = {
  heroCrate: B("hero-crates.jpg"),
  cardboard: B("cardboard-box.jpg"),
  plywoodCrates: B("plywood-crate.jpg"),
  pinewood: B("pinewood-crate.jpg"),
  epeFoam: B("epe-foam.jpg"),
  puFoam: B("pu-egg-tray.jpg"),
  xlpeFoam: B("xlpe-case.jpg"),
  cargo: B("sectors-cargo.jpg"),
  exportPacking: B("export-packing.jpg"),
  plywoodCases: B("plywood-cases.jpg"),
  workFoamNesting: B("work-foam-nesting.jpg"),
  multiCompartment: B("multi-compartment.jpg")
};

export const GALLERY = [
  {
    src: B("work-plywood-cases.png"),
    caption: "Reusable latched plywood export cases",
    span: "md:col-span-2 md:row-span-2"
  },
  {
    src: B("work-foam-nesting.jpg"),
    caption: "EPE foam grid nesting in plywood crate",
    span: "md:col-span-1 md:row-span-1"
  },
  {
    src: B("work-made-in-india.jpg"),
    caption: "Made-in-India corrugated shippers with hand-holds",
    span: "md:col-span-1 md:row-span-1"
  },
  {
    src: B("work-defence-cases.jpg"),
    caption: "Ruggedised strapped cases for defence dispatch",
    span: "md:col-span-1 md:row-span-1"
  },
  {
    src: B("work-corrugated-long.jpg"),
    caption: "Edge-protected long corrugated export cartons",
    span: "md:col-span-1 md:row-span-1"
  },
  {
    src: B("work-foam-lined-case.jpg"),
    caption: "Foam-lined plywood case, ready to load",
    span: "md:col-span-1 md:row-span-1"
  },
  {
    src: B("export-packing.jpg"),
    caption: "Vacuum-foil wrapping & pallet strapping on-site",
    span: "md:col-span-1 md:row-span-1"
  },
  {
    src: B("work-large-crates.jpg"),
    caption: "Large-format plywood crates in production",
    span: "md:col-span-2 md:row-span-1"
  },
  {
    src: B("work-9cell.jpg"),
    caption: "Nine-cell corrugated compartment insert",
    span: "md:col-span-1 md:row-span-1"
  },
  {
    src: B("work-comb-insert.jpg"),
    caption: "Comb-divider insert for long components",
    span: "md:col-span-1 md:row-span-1"
  },
  {
    src: B("work-ispm-pallets.jpg"),
    caption: "ISPM-15 exempt paper & plywood pallets, batch stacked",
    span: "md:col-span-1 md:row-span-1"
  },
  {
    src: B("work-cell-dividers.jpg"),
    caption: "Corrugated cell dividers in production",
    span: "md:col-span-1 md:row-span-1"
  },
  {
    src: B("work-contour-inserts.jpg"),
    caption: "Contoured corrugated inserts for shaped parts",
    span: "md:col-span-1 md:row-span-1"
  },
  {
    src: B("work-pink-cavity.jpg"),
    caption: "Stacked green-edged plywood carry cases",
    span: "md:col-span-1 md:row-span-1"
  },
  {
    src: B("work-green-stack.jpg"),
    caption: "Pink anti-static foam cavity in a green-edged case",
    span: "md:col-span-1 md:row-span-1"
  },
  {
    src: B("work-fine-grid.jpg"),
    caption: "Plywood crate with internal divider compartments",
    span: "md:col-span-1 md:row-span-1"
  },
  {
    src: B("work-plywood-dividers.jpg"),
    caption: "Corrugated tray with fine corrugation partitions",
    span: "md:col-span-1 md:row-span-1"
  }
];

export const PRODUCTS = [
  {
    id: "corrugated",
    index: "01",
    title: "Heavy Duty Corrugated Cardboard",
    spec: "3 / 5 / 7-PLY · EXPORT QUALITY",
    desc: "Export-grade and heavy-duty hybrid corrugated boxes engineered for stacking loads and long-haul export transit.",
    image: IMAGES.cardboard,
    span: "md:col-span-2 md:row-span-1"
  },
  {
    id: "plywood",
    index: "02",
    title: "Plywood Boxes & Crates",
    spec: "18 / 12 / 9 MM · ISPM-15",
    desc: "Export-quality plywood cases in 18/12/9 mm combinations for high-value cargo, machinery and instrumentation.",
    image: IMAGES.plywoodCrates,
    span: "md:col-span-1 md:row-span-2"
  },
  {
    id: "pinewood",
    index: "03",
    title: "Pinewood & Plywood Pallets",
    spec: "HEAT-TREATED · NEEM WOOD",
    desc: "ISPM-15 compliant pinewood & plywood pallets for heavy industrial and defence-grade export consignments.",
    image: IMAGES.pinewood,
    span: "md:col-span-1 md:row-span-1"
  },
  {
    id: "epe",
    index: "04",
    title: "EPE Foam Fitments",
    spec: "EXPANDED POLYETHYLENE",
    desc: "Custom EPE foam fitments in varied thickness — lightweight, resilient cushioning that absorbs shock and vibration.",
    image: IMAGES.epeFoam,
    span: "md:col-span-1 md:row-span-1"
  },
  {
    id: "pu",
    index: "05",
    title: "PU & Egg-Tray Foam",
    spec: "PU · ANTI-STATIC · CONVOLUTED",
    desc: "Die-cut polyurethane, anti-static (pink) and egg-tray / convoluted foam that cushions and grips delicate components.",
    image: IMAGES.puFoam,
    span: "md:col-span-1 md:row-span-1"
  },
  {
    id: "xlpe",
    index: "06",
    title: "XLPE Foam Fitments",
    spec: "CROSS-LINKED PE · DIE-CUT",
    desc: "Closed-cell, high-density foam nesting offering superior compression resistance for precision equipment.",
    image: IMAGES.xlpeFoam,
    span: "md:col-span-2 md:row-span-1"
  }
];

export const SECTORS = [
  {
    no: "01",
    name: "Aerospace & Defence",
    line: "Vibration-controlled crating, ESD foam nesting and ruggedised cases for airframe assemblies, avionics and mission-critical equipment."
  },
  {
    no: "02",
    name: "Electronics & Electrical",
    line: "Anti-static EPE and PU foam packaging for PCBs, drives, control systems and sensitive electronics."
  },
  {
    no: "03",
    name: "Automotive",
    line: "Returnable and one-time packaging for components, castings and utility-vehicle assemblies."
  },
  {
    no: "04",
    name: "Industrial Equipment",
    line: "Heavy-machinery cases, engine crating and structural export packaging with container optimisation."
  },
  {
    no: "05",
    name: "Healthcare",
    line: "Clean, cushioned and secure packaging for medical devices, diagnostics and precision instrumentation."
  }
];

export const CLIENTS = [
  "SKF India",
  "Bharat Electronics",
  "Rossell Techsys",
  "DCX Systems",
  "Sasmos HET Technologies",
  "CIM Tools",
  "Shakti Precision",
  "Bevel Gears India",
  "Rangsons Aerospace",
  "Gopalan Aerospace",
  "Raneal Advanced Systems",
  "Röchling Automotive",
  "Autotech Systems",
  "Avirata Defence Systems",
  "Fokker Elmo Sasmos",
  "BTL India",
  "Raad Systems"
];

export const MANIFESTO = [
  {
    no: "[ 01 ]",
    title: "ENGINEERED, NOT ASSEMBLED",
    body: "Every crate begins as a load calculation. We design and develop packaging around the physics of the product — weight distribution, centre of gravity and transit forces — before a single board is cut."
  },
  {
    no: "[ 02 ]",
    title: "BUILT FOR THE JOURNEY",
    body: "From Whitefield to any port on earth. ISPM-15 compliant timber, optimised container sizing and shock-dampening foam systems engineered for zero damage during transit."
  },
  {
    no: "[ 03 ]",
    title: "PRECISION AT SCALE",
    body: "Trusted by aerospace, defence, electronics and heavy industry leaders — we deliver repeatable, certifiable packaging with the tolerance those sectors demand."
  }
];

export const CAPABILITIES = [
  { k: "ISPM-15", v: "Heat-treated & fumigated timber for global export compliance." },
  { k: "Design & Development", v: "CAD-engineered crates & die-cut foam fitments per SKU." },
  { k: "Container Optimisation", v: "Right-sized packaging that cuts shipping cost & volume." },
  { k: "ESD Protection", v: "Anti-static EPE & PU foam systems for sensitive electronics." },
  { k: "Zero-Damage Transit", v: "Shock & vibration-dampened designs for fragile cargo." },
  { k: "Pan-India Delivery", v: "Reliable dispatch to every state across India, plus worldwide export." },
  { k: "Air & Sea Freight", v: "Designed to the freight mode — lightweight, volumetric-optimised crates for air; rugged, moisture-sealed cases for sea." },
  { k: "On-Site Packing", v: "Turnkey machine crating and export packing at your facility." },
  { k: "Go Green", v: "Eco-first packaging — recyclable corrugate, reusable crates & responsibly-sourced ISPM-15 timber to cut waste." }
];
